<template>
    <div class="types-update-modal">
        <ModalContainer :title="$t('types.edit_type')" identifier="types-update-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_loading_type || is_saving">
                <FormInputText v-model="$v.type.name.$model" identifier="name" :label="$t('types.name')"
                               :disabled="is_loading_type || is_saving" :has-error="$v.type.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.type.name.required">
                            {{$t('validation.x_is_required',{x: $t('types.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import _ from 'lodash';
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "TypesUpdateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        props: {
            type_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                type: {
                    name: null,
                },
                is_saving: false,
                is_loading_type: false,
            }
        },
        validations: {
            type: {
                name: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('types-update-modal', status);
            },
            save() {
                this.$v.type.$touch();
                if (this.$v.type.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                const payload = {
                    name: this.type.name,
                }

                this.$axios.patch(`types/${this.type_id}`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('types.success_updated'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('types.error_update')),
                        type: 'error',
                    });
                });
            },
            async getType() {
                this.is_loading_type = true;

                await this.$axios.get(`types/${this.type_id}`)
                    .then(({data}) => {
                        this.$v.type.name.$model = data.data.attributes.name;
                        this.is_loading_type = false;
                    })
                    .catch(e => {
                        this.is_loading_type = false;

                        this.$notify({
                            title: this.$t('error'),
                            text: this.$larerror(e.response.data, this.$t('types.error_retrieve')),
                            type: 'error',
                        });
                    });
            },
        },
        mounted() {
            this.getType();
        }
    }
</script>
